class ContainerData {
    constructor () {
        this._datasources = {};
        this._reducers = {};
    }

    register ({ reducers = {}, datasources = {} }) {
        this._datasources = { ...this._datasources, ...datasources };
        this._reducers = { ...this._reducers, ...reducers };
    }

    get () {
        return { reducers: this._reducers, datasources: this._datasources };
    }
}

const initialContainerData = new ContainerData();

export default initialContainerData;
